import { useEffect, useState } from "react";
import { useWasScrolled } from "../../hooks/useWasScrolled";

const airportCodesMap = {} as { [key: string]: string };
const originCode = {} as { code?: string };

export const useAirportNames = (destinationCode: string) => {
    const [airportNames, setAirportNames] = useState([null, null] as
        | { code: string; name: string }[]
        | null);
    const wasScrolled = useWasScrolled();

    useEffect(() => {
        if (!wasScrolled) {
            return;
        }
        const fetchOriginCode = async () => {
            const response = await fetch(
                "https://travelpayouts.com/whereami?locale=en-GB"
            );
            const data = await response.json();
            return data?.iata;
        };
        const fetchNames = async () => {
            if (!originCode.code) {
                originCode.code = await fetchOriginCode();
            }
            let codes = [];
            if (!airportCodesMap[originCode.code]) {
                codes.push(originCode.code);
            }
            if (!airportCodesMap[destinationCode]) {
                codes.push(destinationCode);
            }
            if (codes.length) {
                const response = await fetch(`/airportNames`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(codes)
                });
                const data = await response.json();
                for (let key in data) {
                    airportCodesMap[key] = data[key];
                }
            }
            const originName = airportCodesMap[originCode.code];
            const destinationName = airportCodesMap[destinationCode];
            setAirportNames([
                { code: originCode.code, name: originName },
                { code: destinationCode, name: destinationName }
            ]);
        };

        fetchNames();
    }, [destinationCode, wasScrolled]);

    return airportNames;
};
